var nurseslounge_lounge_nursingJobs = {
    init:function($params){
        try{
            nurseslounge_lounge_nursingJobs.jobs_search($params);
        }catch (e) {

        }
    },
    jobs_search:function($params){
        $params = $.extend({},$params, {
            action:'info',
            tab:'jobs'
        });
        var $jobs = $("#nurseslounge-lounge-nursing-jobs");
        var $jobsDown = $jobs.find(".nurseslounge-lounge-nursing-jobs-down");
        var $jobListContainer = $jobsDown.find(".jobs-list-container:first");
        var $preview = nurseslounge_lounge_nursingJobs.jobs_search_list_preview();
        var $bindingResize;
        var $map = new google.maps.Map(document.getElementById('search-location-map'), {
            center: {lat: 29.8550297, lng: -97.9463043},
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoom: 5,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            },
        });
        $map.setTilt(0);
        google.maps.event.trigger($map, 'resize');
        $jobListContainer.html($preview).promise().done(function(){
            nurseslounge_lounge_nursingJobs.nursing_jobs_up_request($params, function($data){
                nurseslounge_lounge_nursingJobs.nursing_jobs_search_map_list($params, $map, $data);
                nurseslounge_lounge_nursingJobs.lounge_jobs_information_edit($params, $data);
            });
        });
        $(window).unbind('resize').resize(function(){
            try{
                clearTimeout($bindingResize);
            }catch (e) {
            }
            $bindingResize = setTimeout(function(){
                $jobListContainer.html($preview).promise().done(function(){
                    nurseslounge_lounge_nursingJobs.nursing_jobs_up_request($params, function($data){
                        nurseslounge_lounge_nursingJobs.nursing_jobs_search_map_list($params, $map, $data);
                        nurseslounge_lounge_nursingJobs.lounge_jobs_information_edit($params, $data);
                    });
                });
            }, 800);
        });
    },
    jobs_search_list_preview:function(){
        var $chtml = '';
        for(var $x=0;$x<10;$x++){
            $chtml+= '' +
                '<li class="p-3 mb-2 bg-white rounded preview">' +
                '    <a href="javascript:void(0)">' +
                '        <div class="row">' +
                '            <div class="col-12 text-center text-sm-right">' +
                '                <div class="d-flex clg-rating float-right mt-n3">' +
                '                    <div class="rating-stars mr-2 inline-table">';
            for(var $s = 1; $s<=5; $s++) {
                $chtml+= '' +
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px">' +
                    '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566" fill="#E2E2E9"></polygon>' +
                    '</svg>';
            }
            $chtml+= '' +
                '                    </div>' +
                '                    <div class="rating-count text-center text-muted text-sm-right nurseslounge-lounge-nursing-jobs-preload">' +
                '                                                &nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;' +
                '                    </div>' +
                '                </div>' +
                '            </div>' +
                '            <div class="col-12 align-self-center">' +
                '                <div class="d-flex">' +
                '                    <div class="profile-img mr-3 nurseslounge-lounge-nursing-jobs-preload">' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                &nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </div>' +
                '                    <div class="list-info align-self-center w-100">' +
                '                        <h4 class="nurseslounge-lounge-nursing-jobs-preload">' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        </h4>' +
                '                        <p class="text-muted nurseslounge-lounge-nursing-jobs-preload">' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        </p>' +
                '                    </div>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </a>' +
                '</li>';
        }
        return $chtml;
    },
    nursing_jobs_up_request:function($params, cback){
        $.ajax({
            url: "/lounge/nursingJobs/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-job-information-edit-modal").modal('hide');
                }
                if($data.status == 'success'){
                    nurseslounge_lounge_nursingJobs.form_set_values($data.data, function(){
                        cback($data);
                    });
                }
            }
        });
    },
    form_set_values:function($data, cback){
        var $jobs = $("#nurseslounge-lounge-nursing-jobs");
        var $jobsDown = $jobs.find(".nurseslounge-lounge-nursing-jobs-down");
        $jobsDown.find(".result-numbers:first").html('<strong>Showing '+$data.total+' </strong>availables<span class="link-color"> Jobs</span>');
        if(cback != undefined){
            cback();
        }
    },
    nursing_jobs_search_map_list:function($params, $map, $data){
        var $mapsMarkers = libs.memoryGet('maps_markers') ? libs.memoryGet('maps_markers') : [];
        $.each($mapsMarkers, function($i, $v){
            $v.setMap(null);
        });
        libs.memorySave('maps_markers', []);
        var $positionSave = [];
        var $bounds = new google.maps.LatLngBounds();
        var $locations = $data && $data.data && $data.data.locations && $data.data.locations ? $data.data.locations : null;
        var $locationsLength = $locations && $locations.length > 0 ? true : false;
        if($locationsLength){
            nurseslounge_jobs.add_map_marker_with_info($map, $locations, $positionSave, true, function(){
                nurseslounge_lounge_nursingJobs.nursing_jobs_pagination($params, $locations, function(){
                    $.each($positionSave, function ($i, $v) {
                        $bounds.extend($v);
                    });
                    if($locations.length > 1){
                        $map.fitBounds($bounds);
                        $map.panToBounds($bounds);
                    }else{
                        $map.fitBounds($bounds);
                        $map.setZoom(20);
                    }
                });
            });
        }else{
            nurseslounge_lounge_nursingJobs.nursing_jobs_pagination($params, $locations, function(){
                if($data.data.location.address_is_unmappable == 0){
                    $map.setCenter({lat:parseFloat($data.data.location.address_latitude),lng:parseFloat($data.data.location.address_longitude)});
                    $map.setZoom(Math.round(14-Math.log(10)/Math.LN2) + 0.7);
                }
            });
        }
        //$map.addListener("click", function(){});
    },
    nursing_jobs_pagination:function($params, $locations, cback){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $jobs = $("#nurseslounge-lounge-nursing-jobs");
        var $jobListContainer = $jobs.find(".nurseslounge-lounge-nursing-jobs-down .jobs-list-container");
        var $paginationContainer = $jobs.find(".nurseslounge-lounge-nursing-jobs-down .pagination-nav");
        var $previewHeight = $jobs.find(".nurseslounge-lounge-nursing-jobs-down .jobs-list-container .preview:first").innerHeight();
        var $jobHeight = $jobListContainer.parents(':first').innerHeight();
        var $pageSize = Math.round(($jobHeight/$previewHeight));
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('nursing_jobs_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationContainer.pagination({
            pageSize: $pageSize > 0 ? $pageSize : 0,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:$locations.filter(function($obj){
                return $obj.employer_have_clicks > 0;
            }),
            callback: function($data, $pagination) {
                $loaded = true;
                if($jobListContainer.length > 0 && $jobListContainer.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$jobListContainer.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $chtml = nurseslounge_jobs.add_map_list_html($params, $data);
                if($chtml == ''){
                    $chtml = '' +
                        '<div class="row w-100 m-0 p-0 mt-lg-5">' +
                        '   <h3 class="w-100 text-center">Jobs for this area coming soon.</h3>' +
                        '   <div class="text-center w-100">' +
                        '       <img src="/bimg/NursesLounge/googlePin.png" class="img-fluid of-contain w-120">' +
                        '   </div>' +
                        '</div>';
                }
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $jobListContainer.html('').html($chtml).promise().done(function(){
                        nurseslounge_lounge_nursingJobs.jobs_map_events(function() {});
                    });
                });
            }
        });
        libs.memorySave('nursing_jobs_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_lounge_nursingJobs.nursing_jobs_pagination($params, $locations, cback);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
        if (cback != undefined) {
            cback();
        }
    },
    jobs_map_events:function(cback){
        var $jobs = $("#nurseslounge-lounge-nursing-jobs");
        var $jobListContainer = $jobs.find(".nurseslounge-lounge-nursing-jobs-down .jobs-list-container");
        var $spu = $jobListContainer.find('.spu');
        var $mapsMarkers = libs.memoryGet('maps_markers');
        var $originalIcon;
        var $originalMarker;
        $spu.unbind();
        $spu.click(function(){
            nurseslounge_jobs.add_map_show_spu($(this).data('key'), $(this).data('facility_key'));
        }).mouseover(function(){
            var $location = $(this).data('location').split(',');
            var $iconUrl = './../../bimg/NursesLounge/onfocus.png';
            $.each($mapsMarkers, function($i, $v){
                var $position = $v.getPosition();
                if(parseFloat($location[0]) == $position.lat() && parseFloat($location[1]) == $position.lng()){
                    $originalMarker = $v;
                    $originalIcon = $originalMarker.getIcon();
                    $originalMarker.setIcon({url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))});
                    return false;
                }
            });
        }).mouseout(function(){
            try{
                $originalMarker.setIcon($originalIcon);
            }catch (e) {

            }
        });
        if(cback != undefined){
            cback();
        }
    },

    add_map_show_spu_request:function($params, cback){
        $.ajax({
            url: "/lounge/nursingJobs/employerList/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }else{
                    $("#nurseslounge-employer-jobs-modal").modal('hide');
                }
            }
        });
    },

    lounge_jobs_information_edit:function($params, $data){
        var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
        $credential = $credential.map(function($x){return parseInt($x);});
        var $allowTabs = {
            'job_information':  $.inArray(19, $credential) != -1 ? true : false,
            'job_location':  $.inArray(19, $credential) != -1 ? true : false
        };
        var $allowTabsFiltered = $allowTabs;
        $allowTabs = {};
        $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
        var $information = $("#nurseslounge-lounge-nursing-jobs");
        var $informationRight = $information.find('.nurseslounge-lounge-nursing-jobs-up:first .administrator:first');
        var $options = $informationRight.find('.option');
        $options.each(function(){
            var $that = $(this);
            var $action = $that.data('action');
            if(
                $action == 'create'
            ) {
                $that.unbind().click(function () {
                    var $tab = null;
                    $.each($allowTabs, function($i, $v){
                        if($v){
                            $tab = $i;
                            return false;
                        }
                    });
                    if(
                        $tab && $action == 'create'
                    ){
                        nurseslounge_job_jobDetail.information_request_select_tab($action, $tab, $allowTabs, $params, function () {
                            $("#nurseslounge-job-information-edit-modal").scrollTop(0);
                            $("#nurseslounge-job-information-edit-modal").modal('show');
                        });
                    }
                });
            }
        });
    },
};
